import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import QuestionImport from '../QuestionImport/QuestionImport';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.questions)
        }}
      >{formatMessage('navTitleQuestions')}</MenuItem>
      {/* <MenuItem
        onClick={() => {
          history.push(routesUrls.presentations)
        }}
      >{formatMessage('navTitleCard')}</MenuItem> */}
   </React.Fragment>
  }
}

const QuestionImportPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <QuestionImport {...props} />
  </Wrapper>
}

export default QuestionImportPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/QuestionImportPage.js